import {useEffect} from 'react';
import {useSideMenuStack} from '../../contexts/SideMenuStackContext';

/**
 * Регистрирует боковую панель матча в стопке открытых и закрывает ее по Esc,
 * если она верхняя из открытых. Esc, уже обработанный кем-то выше (модалка,
 * поле ввода), панель не трогает
 *
 * @param {string} sideMenuId — SIDE_MENU_IDS
 * @param {boolean} isOpen
 * @param {function(): void} onClose
 */
export const useSideMenuEscape = (sideMenuId, isOpen, onClose) => {
  const {topSideMenuId, topOpenSideMenuId, setSideMenuOpen} = useSideMenuStack();
  // Без учета открытых панелей (упрощенный контекст в тестах) верхней
  // считается просто последняя поднятая
  const topId = setSideMenuOpen ? topOpenSideMenuId : topSideMenuId;

  useEffect(() => {
    setSideMenuOpen?.(sideMenuId, isOpen);
  }, [sideMenuId, isOpen, setSideMenuOpen]);

  useEffect(() => () => setSideMenuOpen?.(sideMenuId, false), [sideMenuId, setSideMenuOpen]);

  useEffect(() => {
    if (!isOpen || topId !== sideMenuId) {
      return undefined;
    }
    const handleKeyDown = (event) => {
      if (event.key !== 'Escape' || event.defaultPrevented) {
        return;
      }
      event.preventDefault();
      onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, topId, sideMenuId, onClose]);
};
